/* eslint-disable import/prefer-default-export */
export const drawerWidth = 300
export const appbarHeight = 80
